import React from 'react';
import { InputNumber } from 'antd';
import { toCurrency } from '../../utils/utils';
import { InputNumberProps } from 'antd/lib/input-number';
import FormInput from 'components/FormInput';
import FormItem from 'antd/lib/form/FormItem';
import { isNil } from 'lodash';

export type InputCurrencyProps = {
  currcode: string;
  fieldname?: any;
  noStyle?: boolean;
  comcode?: string;
  col?: boolean;
  md?: number;
  xl?: number;
  rules?: any;
  required?: boolean;
  hideCurrcode?:boolean;
} & InputNumberProps;

const InputCurrency = (props: InputCurrencyProps) => {
  let parseval = '';

  let lcurrcode =
    props?.currcode?.length > 0
      ? props?.currcode
      : localStorage.getItem('currcode');

  switch (lcurrcode) {
    case 'EUR':
      parseval = '€';
      break;
    case 'MAD':
      parseval = 'MAD';
      break;
    case 'XOF':
      parseval = 'XOF';
      break;
    case 'TND':
      parseval = 'TND';
      break;
    case 'USD':
      parseval = '$';
      break;
    default:
      parseval = '€';
  }
  return (
    <FormItem noStyle name={props.currcode}>
      <FormInput
        col={props.col}
        xs={24}
        md={props.md}
        xl={props.xl}
        name={props.fieldname}
        comcode={props.comcode}
        noStyle={props.noStyle ? true : !props.fieldname}
        style={!props.col ? { width: '100%' } : {}}
        rules={[
          { required: props.required ?? false },
          () => ({
            validator(_, value) {
              if (props.required) {
                if (Number(value) === 0 && !isNil(value)) {
                  return Promise.reject(`' ${props.fieldname} ' is required`);
                }
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <InputNumber
          min={0}
          formatter={(value) => toCurrency(value, props.currcode,props.hideCurrcode)}
          parser={(value) =>
            value!
              .replace(parseval, '')
              .replaceAll(',', '')
              .replaceAll(' ', '') ?? 0
          }
          {...props}
        />
      </FormInput>
    </FormItem>
  );
};

export default InputCurrency;
